import {
  getPluginType,
  getPluginOptions,
  getEmptyRowNode,
  ELEMENT_TABLE,
 } from '@udecode/plate';

 import { KEY_DOCUMENT_SETTINGS } from '../../document-settings/createDocumentSettingsPlugin';

export const getEmptyTableNode = (
  editor,
  {
    header,
    rowCount = 0,
    colCount,
    newCellChildren,
  } = {},
) => {
  const rows = Array(rowCount)
    .fill(rowCount)
    .map(() => getEmptyRowNode(editor, { header, colCount, newCellChildren }));

  // Calculate inner width of the document divided by row count so that a new table
  // will have correct col sizes already populated.
  const { innerWidth } = getPluginOptions(editor, KEY_DOCUMENT_SETTINGS);

  const colSize = innerWidth ? innerWidth / colCount : 0;

  return {
    type: getPluginType(editor, ELEMENT_TABLE),
    children: rows,
    colSizes: Array(colCount).fill(colSize),
  };
};
